module.exports = __webpack_public_path__ + "img/logo_200x200.c8b66c38.png";